import { render, staticRenderFns } from "./UserRoleEditor.vue?vue&type=template&id=762d3d5c"
import script from "./UserRoleEditor.vue?vue&type=script&lang=js"
export * from "./UserRoleEditor.vue?vue&type=script&lang=js"
import style0 from "./UserRoleEditor.vue?vue&type=style&index=0&id=762d3d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports